import React, { useEffect, useMemo, useState } from 'react';
import fallbackAvatarUrl from '../../assets/mascot/kork-map.png';
import { getPlayerAvatarSources, normalizeAvatarUrl } from '../../avatar/playerAvatar.mjs';

export default function PlayerAvatarImage({ avatarData, alt = '', className = '', ...imageProps }) {
  const sources = useMemo(
    () => getPlayerAvatarSources(avatarData, fallbackAvatarUrl),
    [avatarData]
  );
  const signature = sources.join('|');
  const [sourceIndex, setSourceIndex] = useState(0);

  useEffect(() => {
    setSourceIndex(0);
  }, [signature]);

  const src = sources[sourceIndex] || normalizeAvatarUrl(fallbackAvatarUrl);
  const preferred2x = sourceIndex === 0
    ? normalizeAvatarUrl(avatarData?.avatarUrl2x ?? avatarData?.avatar_url_2x)
    : '';

  return (
    <img
      {...imageProps}
      className={className}
      src={src}
      srcSet={preferred2x && preferred2x !== src ? `${preferred2x} 2x` : undefined}
      alt={alt}
      loading="eager"
      decoding="async"
      fetchPriority="high"
      data-avatar-source-index={sourceIndex}
      onError={() => setSourceIndex((current) => Math.min(current + 1, sources.length - 1))}
    />
  );
}
